import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { pageSizeFor, spreadSizeFor } from '@kitup/book-schema';
import React, {} from 'react';
const PAGE_BACKGROUND = 'var(--kitup-book-paper, #fffdf9)';
/** Физический разворот: размеры всегда выводятся из `attributes.format`. */
export function SpreadBookPage({ attributes, children, layoutId, showFoldLine = false, style, }) {
    const size = spreadSizeFor(attributes);
    return (_jsxs("div", { "data-kitup-spread": "", "data-layout": layoutId, "data-spread-width-mm": size.widthMm, "data-spread-height-mm": size.heightMm, style: {
            position: 'relative',
            width: `${size.widthMm}mm`,
            height: `${size.heightMm}mm`,
            overflow: 'hidden',
            boxSizing: 'border-box',
            background: PAGE_BACKGROUND,
            isolation: 'isolate',
            ...style,
        }, children: [children, showFoldLine ? (_jsx("div", { "aria-hidden": "true", "data-fold-line": "", style: {
                    position: 'absolute',
                    zIndex: 20,
                    insetBlock: 0,
                    left: '50%',
                    width: '0.2mm',
                    transform: 'translateX(-50%)',
                    background: 'repeating-linear-gradient(to bottom, rgba(255,255,255,.72) 0 2mm, transparent 2mm 4mm)',
                    pointerEvents: 'none',
                } })) : null] }));
}
/** Одна физическая страница — основа обложек и печатных одиночных листов. */
export function StoryBookPage({ attributes, children, backgroundColor = PAGE_BACKGROUND, style, }) {
    const size = pageSizeFor(attributes);
    return (_jsx("div", { "data-kitup-page": "", "data-page-width-mm": size.widthMm, "data-page-height-mm": size.heightMm, style: {
            position: 'relative',
            width: `${size.widthMm}mm`,
            height: `${size.heightMm}mm`,
            overflow: 'hidden',
            boxSizing: 'border-box',
            background: backgroundColor,
            ...style,
        }, children: children }));
}
//# sourceMappingURL=page.js.map